module.exports = __webpack_public_path__ + "static/media/Tupe3.a68abf72.webp";